var React = require('react');

function Section2BottomMiddleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("polygon",{"fill":"#45B8C1","points":"189.915 158 155 134.646 177.09 118","key":0}),React.createElement("circle",{"cx":"60","cy":"144","r":"18","fill":"#E9D8FD","key":1}),React.createElement("polygon",{"fill":"#C5F6D5","points":"18.306 100.426 60.426 118.306 42.547 160.426 .426 142.547","transform":"rotate(-45 30.426 130.426)","key":2}),React.createElement("rect",{"width":"79.004","height":"79.004","x":"63.294","y":"17.294","fill":"#FED7D7","transform":"rotate(45 102.796 56.796)","key":3})]));
}

Section2BottomMiddleInline.defaultProps = {"width":"190","height":"162","viewBox":"0 0 190 162"};

module.exports = Section2BottomMiddleInline;

Section2BottomMiddleInline.default = Section2BottomMiddleInline;
